export function initHomepageVideo(video: HTMLElement | null) {
    async function updateSrc({ matches }: MediaQueryList | MediaQueryListEvent) {
        if (!(video instanceof HTMLVideoElement)) {
            return;
        }

        video.src = `https://mizkan.s3.eu-west-2.amazonaws.com/branston/chilli-piccalilli/header-${matches ? 'desktop' : 'mobile'}.mp4`;

        return video.play().catch(() => {});
    }

    const mq = window.matchMedia('(min-width: 600px)');
    mq.addListener(updateSrc);
    updateSrc(mq);
}
